import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useEffect, useMemo } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { StorageClearer } from '../classes/StorageClearer/StorageClearer';
import { StopwatchManager } from '../classes/timeTracking/StopwatchManager/StopwatchManager';
import { StopwatchManagerContext, StopwatchManagerContextValue } from '../context/StopwatchManagerContext';
import { useInitializable } from '../hooks/useInitializable/useInitializable';
export const AppStopwatchManagerContextProvider: FunctionComponent<PropsWithChildren> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children
  } = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      createInstance: _temp
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    initializable: stopwatchManager
  } = useInitializable(t1);
  let t2;
  let t3;
  if ($[3] !== stopwatchManager) {
    t2 = () => {
      const disposable = StorageClearer.registerAfterClearTask(() => stopwatchManager?.clear());
      return () => {
        disposable.dispose();
      };
    };
    t3 = [stopwatchManager];
    $[3] = stopwatchManager;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== stopwatchManager) {
    t4 = stopwatchManager ? {
      stopwatchManager
    } : null;
    $[6] = stopwatchManager;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const contextValue = t4;
  if (!contextValue) {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div>Intializing StopwatchManager..</div>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t5;
  if ($[9] !== children || $[10] !== contextValue) {
    t5 = <StopwatchManagerContext.Provider value={contextValue}>{children}</StopwatchManagerContext.Provider>;
    $[9] = children;
    $[10] = contextValue;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
});
function _temp() {
  return new StopwatchManager();
}